import React from 'react';
import { Button, Typography } from '@mui/material';
import { StudioFlowColors, StudioFlowRadii } from '../studioFlowTheme';

interface FlowContinueButtonProps {
  summary: string;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const FlowContinueButton: React.FC<FlowContinueButtonProps> = ({
  summary,
  onClick,
  disabled = false,
  fullWidth = true,
}) => (
  <Button
    type="button"
    onClick={onClick}
    disabled={disabled}
    fullWidth={fullWidth}
    sx={{
      bgcolor: disabled ? StudioFlowColors.disabled : StudioFlowColors.primary,
      color: '#FFFFFF',
      borderRadius: `${StudioFlowRadii.pill}px`,
      minHeight: 52,
      py: 0.75,
      textTransform: 'none',
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      boxShadow: 'none',
      '&:hover': {
        bgcolor: disabled ? StudioFlowColors.disabled : StudioFlowColors.primaryHover,
        boxShadow: 'none',
      },
      '&.Mui-disabled': {
        bgcolor: StudioFlowColors.disabled,
        color: StudioFlowColors.disabledText,
      },
    }}
  >
    <Typography
      sx={{
        fontFamily: StudioFlowColors.bodyFontFamily,
        fontWeight: 700,
        fontSize: 17,
        lineHeight: 1.3,
        letterSpacing: '-0.17px',
        color: 'inherit',
      }}
    >
      Continue
    </Typography>
    <Typography
      sx={{
        fontFamily: StudioFlowColors.bodyFontFamily,
        fontWeight: 450,
        fontSize: 13,
        lineHeight: 1.5,
        letterSpacing: '-0.13px',
        color: 'inherit',
      }}
    >
      {summary}
    </Typography>
  </Button>
);
